export function useScrollContainer() {
  const scrollContainer = useState<HTMLElement | null>('mobileScrollContainer')

  return {
    scrollContainer,
  }
}
